(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-rating-dynamic"] && !Shopify.designMode) return;
  try {
    (() => {
    const API_URL = 'https://api.trustifyreview.com/reviews/statistic';
    const CACHE_PREFIX = 'trustify-rating:';
    const requests = {};

    const readCache = (key) => {
      try {
        const value = sessionStorage.getItem(CACHE_PREFIX + key);
        return value ? JSON.parse(value) : null;
      } catch (error) {
        return null;
      }
    };

    const writeCache = (key, value) => {
      try {
        sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(value));
      } catch (error) {
        // Storage unavailable: the rating is simply fetched again next time
      }
    };

    const fetchStatistic = (shop, productId) => {
      const key = `${shop}:${productId}`;
      const cached = readCache(key);

      if (cached) {
        return Promise.resolve(cached);
      }

      if (!requests[key]) {
        const url = `${API_URL}?shop=${encodeURIComponent(shop)}&product_id=${encodeURIComponent(productId)}`;

        requests[key] = fetch(url)
          .then((response) => response.json())
          .then((json) => {
            const statistic = {
              average: Number(json?.data?.rating_avg) || 0,
              count: Number(json?.data?.total_rating) || 0,
            };
            writeCache(key, statistic);
            return statistic;
          })
          .catch(() => null);
      }

      return requests[key];
    };

    const render = (element, statistic) => {
      if (!statistic || (statistic.count === 0 && element.dataset.hideEmpty !== 'false')) {
        return;
      }

      const average = Math.round(statistic.average * 10) / 10;
      const label = `${average} / 5 (${statistic.count})`;

      element.querySelector('.card-stars__fill').style.width = `${(statistic.average / 5) * 100}%`;
      element.querySelector('.card-stars').setAttribute('aria-label', label);
      element.title = label;

      const countElement = element.querySelector('.card-stars__count');
      if (countElement) {
        countElement.textContent = `(${statistic.count})`;
      }

      element.hidden = false;
    };

    const init = () => {
      document.querySelectorAll('[data-trustify-rating]:not([data-trustify-loaded])').forEach((element) => {
        element.setAttribute('data-trustify-loaded', '');
        fetchStatistic(element.dataset.shop, element.dataset.productId).then((statistic) => render(element, statistic));
      });
    };

    let timer;
    const scheduleInit = () => {
      clearTimeout(timer);
      timer = setTimeout(init, 100);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Filters, sorting and pagination replace the product list without a full page load
    new MutationObserver(scheduleInit).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
